module.exports = __webpack_public_path__ + "img/om.ba5a7dbf.png";